import React, { useEffect, useRef } from 'react';
import { generateClient } from '@aws-amplify/api';
import { onUpsertTableChangelog } from '@/graphql/subscriptions';
import { getQueueTasks, getRecruitmentSources, getSegments, getSites, getStudies, getSubjects, getSubjectContacts, getWorkflows } from '@/graphql/queries';
import _ from 'lodash';

const client = generateClient();

const rankings_config = {
    queue_task: {
        query: getQueueTasks,
        results: r => r?.data.getQueueTasks.rankings || []
    },
    recruitment_sources: {
        query: getRecruitmentSources,
        results: r => r?.data.getRecruitmentSources.rankings || []
    },
    segments: {
        query: getSegments,
        results: r => r?.data.getSegments.rankings || []
    },
    sites: {
        query: getSites,
        results: r => r?.data.getSites.rankings || []
    },
    studies: {
        query: getStudies,
        results: r => r?.data.getStudies.rankings || []
    },
    subjects: {
        query: getSubjects,
        results: r => r?.data.getSubjects.rankings || []
    },
    subject_contacts: {
        query: getSubjectContacts,
        results: r => r?.data.getSubjectContacts.rankings || []
    },
    workflows: {
        query: getWorkflows,
        results: r => r?.data.getWorkflows.rankings || []
    }
};

/**
 * Custom hook for "Load More" button
 */
export default ({ filters_ref, limit_ref, offset_ref, rankings_key, setData, setRows } = {}) => {
    const subscriptions = useRef([]);
    useEffect(() => {
        if (!rankings_key) return;
        // Disable for now
        return;
        subscriptions.current.push(client.graphql({	query: onUpsertTableChangelog, variables: {} }).subscribe({
        next: async ({ data }) => {
            // These are the updates for subjects
            const items = data.onUpsertTableChangelog[rankings_key];
            if (items?.length > 0) {
                setData && setData(id => {
                    let newData;
                    items.forEach(_item => {
                        if (_item.id === id) {
                            newData = _item;
                        }
                    });
                    return newData;
                });
                if (setRows) {
                    // Get rankings
                    const { filters, sorting, top_filters } = filters_ref ? filters_ref.current : {};
                    const limit = limit_ref ? { limit: limit_ref.current + (offset_ref ? offset_ref.current : 0) } : undefined;
                    const use_id = rankings_key === 'subject_contacts' ? 'contact_id' : 'id';
                    const id_filter = { [use_id]: items.map(e => e[use_id]) };
                    const rankings = rankings_config[rankings_key].results(await client.graphql({
                        query: rankings_config[rankings_key].query,
                        variables: { ...top_filters, ...id_filter, filters, is_rankings: true, ...limit, sorting, subject_contacts_limit: 1 }
                    }));
                    console.log('rankings', rankings);
                    setRows(prevRows => {
                        const newRows = [...prevRows];
                        items.forEach(_item => {
                            // Does id exist in rankings? If not, it means it does not fit the current filter
                            const rank = rankings.find(e => e[use_id] === _item[use_id]);
                            // See if it is an update or a new
                            const idx = newRows.findIndex(e => e[use_id] === _item[use_id]);
                            if (idx !== -1) {
                                if (!rank) {
                                    // Remove as it is no longer fitting the current filter
                                    newRows.splice(idx, 1);
                                } else {
                                    // Replace existing item and relocate to rank.row_num
                                    newRows.splice(idx, 1);
                                    newRows.splice(rank.row_num - 1, 0, _item);
                                }
                            } else {
                                if (rank) {
                                    // Insert new item
                                    newRows.splice(rank.row_num - 1, 0, _item);
                                }
                            }
                        });
                        return newRows;
                    });
                }
            }
        },
        error: (error) => {
            console.error('Subscription error:', error);
        }
        }));
        return () => {
        subscriptions.current.forEach(e => e.unsubscribe());
        };
    }, []);
};
